import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import { makeStyles } from '@material-ui/core/styles';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { color } from '../../app/theme';
import { setNodeById, setSelectedNode } from '../../features/mainSlice';
import { getOrganizationMembers } from '../../features/organizationSlice';
import AutocompletePanel from '../shared/AutocompletePanel';
import Dropdown from '../shared/Dropdown';
import TextFieldSearch from '../shared/TextFieldSearch';
import Mask from './SettingBarMask';

const useStyles = makeStyles(
  {
    top: {
      fontSize: '17px',
      fontWeight: 'normal',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: '1',
      letterSpacing: 'normal',
      color: color.$3,
      background: color.$9,
      textAlign: 'center',
      padding: '18px 0 21px',
    },
    bottom: {
      padding: '24px 16px',
      overflowY: 'auto',
      height: 'calc(100vh - 170px)',
    },
    title: {
      fontSize: '15px',
      fontWeight: '400',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: '21px',
      letterSpacing: 'normal',
      color: color.$3,
      marginBottom: 12,
    },
    menuContainer: {
      maxHeight: '192px',
      overflowY: 'auto',
      padding: '8px 0',
      borderRadius: '0px 0px 12px 12px',
    },
    customerRow: {
      position: 'relative',
      padding: '6px 24px',
      margin: 0,
    },
    paperClass: {
      width: 300,
      zIndex: 3,
    },
    customer: {
      position: 'relative',
    },
    inboxDropdown: {
      marginBottom: 12,
    },
  },
  {
    name: 'TagSettingBar',
  },
);

let findMemberTimer = null;

const TagSettingBar = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { selectedNode, isErrorNodeIds } = useSelector(state => state.ma);
  const { membersList = [] } = useSelector(store => store.organization);

  const [searchCustomerTerm, setSearchCustomerTerm] = useState('');
  const [isCustomerOpen, setIsCustomerOpen] = useState(false);

  const { data } = selectedNode || {};
  const { inbox, userId, displayName } = data || {};
  const isError = !!~isErrorNodeIds.indexOf(selectedNode?.id);

  const memberList = useMemo(() => {
    return membersList.map(m => ({
      ...m,
      displayName: `${m?.firstName} ${m?.lastName}`,
    }));
  }, [membersList]);

  const customerServiceItems = [
    {
      text: t(`unassigned`),
      value: 'unassigned',
    },
    {
      text: t(`private`),
      value: 'private',
    },
    {
      text: t(`done`),
      value: 'done',
    },
  ];

  const onMemberChange = async value => {
    clearTimeout(findMemberTimer);
    findMemberTimer = setTimeout(() => {
      dispatch(
        getOrganizationMembers({
          limit: 20,
          keyword: value,
        }),
      );
    }, 1000);
  };

  const handleChangeSearchCustomerTerm = v => {
    if (!v) {
      const newNode = {
        ...selectedNode,
        data: {
          ...data,
          displayName: '',
          userId: '',
        },
      };

      dispatch(setSelectedNode(newNode));
      dispatch(setNodeById(newNode));
    }
    setSearchCustomerTerm(v);
    onMemberChange(v);
  };

  const handleCustomerClick = customer => {
    setSearchCustomerTerm('');
    setIsCustomerOpen(false);

    const newNode = {
      ...selectedNode,
      data: {
        ...data,
        displayName: customer?.displayName,
        userId: customer?.objectId,
      },
    };

    dispatch(setSelectedNode(newNode));
    dispatch(setNodeById(newNode));
  };

  const handleChangeInbox = v => {
    const newNode = {
      ...selectedNode,
      data: {
        ...data,
        inbox: v,
        displayName: '',
        userId: '',
      },
    };

    dispatch(setSelectedNode(newNode));
    dispatch(setNodeById(newNode));
  };

  return (
    <>
      <div className={classes.top}>{t('inbox-node')}</div>
      <div id="inbox-setting-bar-bottom" className={classes.bottom}>
        <div>
          <div className={classes.title}>{t('inboxTitle')}</div>
          <Dropdown
            className={classes.inboxDropdown}
            isDialog
            menuItems={customerServiceItems}
            value={inbox}
            onChange={handleChangeInbox}
          />
          {inbox === 'private' && (
            <ClickAwayListener
              onClickAway={() => {
                setIsCustomerOpen(false);
                setSearchCustomerTerm('');
              }}
            >
              <div className={classes.customer}>
                <TextFieldSearch
                  value={searchCustomerTerm || displayName || ''}
                  placeholder={t(`selectAssignedUser`)}
                  onChange={handleChangeSearchCustomerTerm}
                  onFocus={() => setIsCustomerOpen(true)}
                  status={isError && !userId ? 'error' : 'default'}
                />
                {isCustomerOpen && memberList.length > 0 && (
                  <AutocompletePanel
                    paperClass={classes.paperClass}
                    menuContainerClass={classes.menuContainer}
                    body1Class={classes.customerRow}
                    dataArray={memberList}
                    value="displayName"
                    extraContent=""
                    extraPicture
                    handleClick={handleCustomerClick}
                    popup
                  />
                )}
              </div>
            </ClickAwayListener>
          )}
        </div>
      </div>
      <Mask mainId="tag-setting-bar-bottom" />
    </>
  );
};

export default TagSettingBar;
